const stickyCartInit = () => {
  const Selector = {
    stickyCart: 'sticky-cart',
    element: 'sb-product-attr__option',
    inputs: 'sticky-cart__fields',
    cart: 'single_add_to_cart_button',
  };

  const stickyCart: HTMLElement = document.querySelector(`.${Selector.stickyCart}`);
  const inputs = Array.from(stickyCart.querySelectorAll(`.${Selector.inputs}`));
  const checkout: HTMLButtonElement = stickyCart.querySelector(`.${Selector.cart}`);

  const checkInputs = () => {
    const check = inputs.every((element: HTMLInputElement) => element.value !== '');

    if (!checkout) return;

    checkout.disabled = true;

    if (check) {
      checkout.disabled = false;
    }
  };

  checkInputs();
};

export default stickyCartInit;
